import lang from "./lang";

class Bool {
    format(value) {
        let text;
        if(lang.isNullOrUndefined(value)) {
            text = '';
        } else {
            text = value.toString();
        }
        return text;
    }
    parse(text) {
        let value;
        if(text==='true') {
            value = true;
        } else if(text==='false') {
            value = false;
        } else {
            value = null;
        }
        return value;
    }
}

const bool = new Bool();

export default bool;